import { get } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import "./styles.scss"

export default createModule({
  view,
  mapStateToProps: (state) => ({
    ...state.modules.staticAlert,
    account: get(state, "global.selected.accountId"),
  }),
  actions: {
    ...Creators,
  },
})
